import { IAudio, IVoiceover } from '@/shared/components/types.ts';
import { MaybeNull } from '@/shared/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useVoiceoverStore = defineStore('voiceoverStoreOld', () => {
  // permission to reproduce the audio dubbing of the verse
  const voiceoverEnabled = ref(JSON.parse(localStorage.getItem('sound-enabled') || 'true'));

  // audio voiceover of the verse of the current active slide
  const activeSlideVoiceover = ref<MaybeNull<IAudio>>(null);

  const voiceovers = ref<IVoiceover[]>([]);

  return {
    voiceoverEnabled,
    activeSlideVoiceover,
    voiceovers,
  };
});
